import { render, staticRenderFns } from "./PrincipalsAdmin.vue?vue&type=template&id=4596a048"
import script from "./PrincipalsAdmin.js?vue&type=script&lang=js&external"
export * from "./PrincipalsAdmin.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports